<template>
  <el-container id="app">
    <el-aside>
      <app-name></app-name>

      <el-menu :default-active="activeRouteName">
        <el-menu-item index="carriers-detail"
                      @click="goTo({ name: 'carriers-detail'})">
          {{ $t('CARRIERS_DETAIL.TITLE') }}
        </el-menu-item>
        <el-menu-item index="rate-requests-list"
                      @click="goTo({ name: 'rate-requests-list'})">
          {{ $t('RATE_REQUESTS_LIST.TITLE') }}
        </el-menu-item>
        <el-menu-item index="contracts-list"
                      @click="goTo({ name: 'contracts-list'})">
          {{ $t('CONTRACTS_LIST.TITLE') }}
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container direction="vertical">
      <app-header></app-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from './components/header/Header'
import AppName from './components/name/Name'

export default {
  components: { AppName, AppHeader },
  computed: {
    activeRouteName () {
      return this.$route.name
    }
  },
  methods: {
    goTo (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  .el-aside {
    border-right: 1px solid #DCDFE6;

    .app-name {
      padding: 16px 24px;
    }

    .el-menu {
      border: none;
    }
  }
}
</style>
